<template>
<transition :name="transitionName" @after-leave="afterLeave">
    <div
        ref="wrapper"
        :class="bem('wrapper', {centered})"
        v-show="mounted && (innerVisible || visible)"
        :style="{zIndex: zIndex, position: appendBody ? 'fixed' : 'absolute'}"
        @click="close"
    >
        <div
            :class="[bem([theme, { full }]), customClass]"
            :style="{width, top: centered ? 'auto' : top, bottom}"
        >
            <div :class="dialogClass">
                <slot name="close">
                    <Icon
                        v-if="showClose"
                        @click.native="onClickOverlay(false)"
                        :class="closeClasses"
                        name="gdd-close"
                    />
                </slot>
                <div v-if="!full" :class="bem('header')">
                    <!-- 头部 会覆盖 title -->
                    <span :class="bem('title')">
                        <slot name="title">{{title}}</slot>
                    </span>
                </div>
                <div :class="bem('body')">
                    <!-- modal内容 -->
                    <slot>
                        <VNode :content="content" />
                    </slot>
                </div>
                <div :class="bem('footer')" v-if="hasFooter && !full">
                    <!-- 底部 -->
                    <slot name="footer">
                        <div :class="bem('footer-left')">
                            <slot name="footer-left"/>
                        </div>
                        <div :class="bem('footer-right')">
                            <slot name="footer-right">
                                <Button
                                    v-if="cancelText"
                                    v-bind="{
                                        type: 'secondary',
                                        ...cancelProps,
                                        disabled: (cancelProps && cancelProps.disabled) || onCancelLoading
                                    }"
                                    @click="cancel"
                                >{{cancelText}}</Button>
                                <Button
                                    v-if="okText"
                                    v-bind="{
                                        type: 'primary',
                                        ...okProps,
                                        disabled: (okProps && okProps.disabled) || onOkLoading
                                    }"
                                    @click="confirm"
                                >{{okText}}</Button>
                            </slot>
                        </div>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</transition>

</template>
<script>
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { bemMixin } from '../utils';
import popupManager from '@gaoding/popup-manager';
import Button from '../button/index.vue';
import Icon from '../icon';
import VNode from '../v-node/index.vue';
export default {
  name: 'g-dialog',
  components: {
    Icon,
    Button,
    VNode
  },
  mixins: [bemMixin],
  props: {
    // 是否可见
    visible: {
      type: Boolean,
      default: false
    },
    // 显示遮罩层
    mask: {
      type: Boolean,
      default: true
    },
    // 不包含头尾
    full: {
      type: Boolean,
      default: false
    },
    transitionName: {
      type: String,
      default: 'gd-modal-fade'
    },
    // 是否支持键盘esc关闭
    keyborad: {
      type: Boolean,
      default: true
    },
    // 标题
    title: {
      type: String,
      default: ''
    },
    content: {
      type: [Object, String, Function],
      default: ''
    },
    appendBody: {
      type: Boolean,
      default: true
    },
    // modal 宽度
    width: {
      type: String,
      default: '384px'
    },
    top: {
      type: String,
      default: '15%'
    },
    theme: {
      type: String,
      default: 'light' // light or dark

    },
    bottom: {
      type: String,
      default: 'auto'
    },
    // Dialog 的自定义类名
    customClass: [String, Object, Array],
    // 显示关闭按钮
    showClose: {
      type: Boolean,
      default: true
    },
    // full 为 true 时，关闭按钮的位置
    closePosition: {
      type: String,
      default: 'outer',

      validator(value) {
        return ['outer', 'inner'].indexOf(value) !== -1;
      }

    },
    // 自定义关闭按钮文笔
    closeText: {
      type: String,
      default: null
    },
    // 确认按钮文字
    okText: {
      type: String,
      default: ''
    },
    // 取消按钮文字
    cancelText: {
      type: String,
      default: ''
    },
    // 点击遮罩层是否允许关闭
    maskClosable: {
      type: Boolean,
      default: false
    },
    onCancel: {
      type: Function,
      default: null
    },
    afterClose: {
      type: Function,
      default: null
    },
    // 居中
    centered: {
      type: Boolean,
      default: false
    },
    onOk: {
      type: Function,
      default: null
    },
    cancelProps: {
      type: Object,
      default: null
    },
    dialogClass: {
      type: [Array, String],
      default: ''
    },
    okProps: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      zIndex: popupManager.getZindex(),
      innerVisible: false,
      mounted: false,
      onOkLoading: false,
      onCancelLoading: false
    };
  },

  computed: {
    closeClasses() {
      return this.bem('close', this.full && this.closePosition === 'outer' ? 'outer' : 'inner');
    },

    hasFooter() {
      return this.okText || this.cancelText || this.$slots.footer || this.$slots['footer-left'] || this.$slots['footer-right'];
    }

  },
  watch: {
    visible(value) {
      if (value) {
        popupManager.pushStack(this);
      } else if (!value) {
        popupManager.popStack(this);
      }
    },

    innerVisible(value) {
      if (value) {
        popupManager.pushStack(this);
      } else if (!value) {
        popupManager.popStack(this);
      }
    }

  },

  mounted() {
    this.mounted = true;
    if (this.visible) popupManager.pushStack(this);
  },

  beforeDestroy() {
    if (this.appendBody && this.$el.parentElement) {
      this.$el.parentElement.removeChild(this.$el);
    }

    popupManager.popStack(this);
  },

  methods: {
    close(e) {
      if (this.maskClosable && e.target === this.$refs.wrapper) {
        this.$emit('update:visible', false);

        if (this.$close) {
          this.$close();
        }
      }
    },

    confirm() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.onOk) {
                  _context.next = 15;
                  break;
                }

                _this.onOkLoading = true;
                _context.prev = 2;
                _context.next = 5;
                return _this.onOk();

              case 5:
                res = _context.sent;
                _this.onOkLoading = false;
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                _this.onOkLoading = false;
                throw _context.t0;

              case 13:
                if (!(res === false)) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return");

              case 15:
                if (!_this.$onOk) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return", _this.$onOk(res));

              case 17:
                _this.$emit('update:visible', false);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 9]]);
      }))();
    },

    cancel() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.onCancel) {
                  _context2.next = 15;
                  break;
                }

                _this2.onCancelLoading = true;
                _context2.prev = 2;
                _context2.next = 5;
                return _this2.onCancel();

              case 5:
                res = _context2.sent;
                _this2.onCancelLoading = false;
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](2);
                _this2.onCancelLoading = false;
                throw _context2.t0;

              case 13:
                if (!(res === false)) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return");

              case 15:
                if (!_this2.$onCancel) {
                  _context2.next = 17;
                  break;
                }

                return _context2.abrupt("return", _this2.$onCancel());

              case 17:
                _this2.$emit('update:visible', false);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 9]]);
      }))();
    },

    onClickOverlay() {
      if (this.showClose) {
        this.$emit('close');
        this.$emit('update:visible', false);

        if (this.$close) {
          this.$close();
        }
      }
    },

    afterLeave() {
      if (this.$afterClose) return this.$afterClose();
      if (this.afterClose) this.afterClose();
    }

  }
};
</script>
<style>
.g-dialog__wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  color: #606266;
  overflow: auto;
}
.g-dialog__wrapper * {
  box-sizing: border-box;
}
.g-dialog__wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.g-dialog__wrapper::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: #e1e5f5;
}
.g-dialog__wrapper::-webkit-scrollbar-track {
  border-radius: 3px;
}
.g-dialog__wrapper--overlay {
  background: hsla(0, 0%, 100%, 0.8);
}
.g-dialog__wrapper--centered {
  text-align: center;
}
.g-dialog__wrapper--centered::before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  width: 0;
}
.g-dialog__wrapper--centered .g-dialog {
  text-align: left;
  vertical-align: middle;
  display: inline-block;
}
.g-dialog {
  margin: 0;
  padding: 0;
  margin: 0 auto;
  position: relative;
  outline: 0;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0px 16px 32px 2px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #000;
}
.g-dialog * {
  box-sizing: border-box;
}
.g-dialog--full .g-dialog__body {
  padding: 24px;
}
.g-dialog--dark {
  background: #000;
  color: #fff;
}
.g-dialog__header {
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.g-dialog__title {
  color: #000;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
}
.g-dialog__close {
  position: absolute;
  top: 18px;
  right: 24px;
  font-size: 20px;
  cursor: pointer;
  opacity: 0.6;
}
.g-dialog__close--outer {
  top: 0;
  right: -60px;
  font-size: 40px;
  color: #fff;
}
.g-dialog__close:hover {
  opacity: 1;
}
.g-dialog__close::after {
  content: '';
  position: absolute;
  left: -4px;
  right: -4px;
  top: -4px;
  bottom: -4px;
}
.g-dialog__footer {
  padding: 20px 24px;
  font-size: 0;
  display: flex;
  justify-content: space-between;
}
.g-dialog__footer .g-btn {
  min-width: 80px;
}
.g-dialog__footer .g-btn + .g-btn {
  margin-left: 8px;
}
.g-dialog__footer .g-btn:first-child.g-btn:last-child .g-btn__content {
  justify-content: center;
}
.g-dialog__body {
  padding: 4px 24px 20px;
  flex: 1 1 auto;
  font-size: 14px;
}
.gd-modal-fade-enter-active {
  animation: gd-modal-fade-in 0.3s;
}
.gd-modal-fade-leave-active {
  animation: gd-modal-fade-out 0.3s;
}
@keyframes gd-modal-fade-in {
  0% {
    transform: translate3d(0, -40px, 0);
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes gd-modal-fade-out {
  0% {
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}

</style>
